import React from 'react';
import PropTypes from 'prop-types';

export default function ATTHOME({ twilioNumber }) {
  return (
    <div>
      <ul>
        <li>Call AT&T at 800-660-3000 and when prompted, enter your main business phone number</li>
        <li>
          Once you reach a service rep, please tell them the verification pin which is usually last
          4 digits of your account number. Rep will help you find it on your bill.
        </li>
        <li>
          Please tell them that you want to set-up &quot;Call forwarding - No answer&quot;
          and &quot;Call forwarding - Busy line&quot; on your business phone number
          to your new {twilioNumber}
        </li>
      </ul>
    </div>
  );
}

ATTHOME.defaultProps = {
  twilioNumber: '',
};

ATTHOME.propTypes = {
  twilioNumber: PropTypes.string,
};
